import { render } from "./DuyuruSeridi.vue?vue&type=template&id=4224e37a"
import script from "./DuyuruSeridi.vue?vue&type=script&lang=js"
export * from "./DuyuruSeridi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__